<template>

    <div v-show="show" class="bee_sgin_base_dialog_layout" @click="doClose()">


        <div class="bee_task_dialog_layout">

            <div class="bee_task_success_layout" @click.stop="doc()">


                <div class="bee_content_suceess_main">

                    <div class="check_in_top">

                    </div>

                    <div>
                        <div id="lottieId" class="icon_check_icon_lot"></div>
                    </div>

                    <div class="dialog_title">Check-in Success</div>

                    <p class="dialog_intro">+<span style="
font-size: 18px;
font-weight: 500;
line-height: 25.2px;
text-align: left;
">{{ xp_String }}</span>XP
                    </p>

                    <div class="w_r_bg">
                        <div class="check_ll_sp">

                        </div>


                        <div class="dialog_send" @click.stop="doClose()">
                            Ok
                        </div>
                    </div>


                </div>
            </div>

            <div class="dialog_close_layout">

                <div class="icon_app_close_img" @click.stop="doClose()" />

            </div>
        </div>


    </div>


</template>

<script>

import icon_sign from '../../assets/checkIN-XP.png';
import { addEmit, resultEmitEvent } from "../../util/event.js";
import lottie from 'lottie-web';
import animationData from '../../assets/loadjson.json';
import {
    baseUrl
} from "../../util/mock.js"

export default {
    name: 'successDialog',
    components: {},
    props: {
    },

    emits: ["show", "cancel"],

    data() {
        return {
            show: false,
            xp_String: "0",
            signIcon: "",
            lottieOptions: {
                container: document.getElementById('lottieId'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                animationData: animationData
            },
            lottieInstance: null,
        }
    },

    watch: {

    },

    methods: {
        doc() {

        },
        doContet() {

        },
        doClose() {
            this.show = false;
        },
        async showDialog(xp) {
            this.xp_String = xp;
            this.show = true;
            this.lottieInstance = await lottie.loadAnimation({
                container: document.getElementById('lottieId'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData: animationData
            });
            this.lottieInstance.play();

        },



    },

    async mounted() {
        // console.log("====mounted=");
        this.signIcon = icon_sign;
        // console.log("====mounted =end=");
    },


}

</script>

<style scoped>
.icon_app_top_img {
    width: 115px;
    height: 115px;
    margin-bottom: -40px;
    background-image: url("../../assets/icon_task_success.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}



.h_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.input_css {
    min-height: 32px;
    border: none;
    outline: none;
    border-width: 1px;
    border-color: gray;
    border-radius: 8px;
    min-width: 60%;
}

.bee_sgin_base_dialog_layout {
    position: fixed;
    z-index: 3001;
    transition: transform 700ms;
    background: rgba(0, 0, 0, 0.60);
    width: 100vw;
    height: 100vh;
}

.bee_task_dialog_layout {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
}

.bee_task_success_layout {
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
}


.bee_content_suceess_main {
    border-radius: 12px;
    /* background: linear-gradient(90deg, #FAFFEF 0%, #FFF4E2 100%); */
    background: #fff;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
}

.dialog_send {
    border-radius: 50px;
    background: #ffc04d;
    color: #FFF;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    line-height: 32px;
    /* 166.667% */
    letter-spacing: 0.12px;
    height: 32px;
    margin-top: 24px;
    width: 140px;
}

.nu_dialog_send {
    border-radius: 50px;
    background: #FFDF9B;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    line-height: 38px;
    /* 166.667% */
    letter-spacing: 0.12px;
    height: 38px;
    margin-top: 24px;
    width: -webkit-fill-available;
    width: -moz-available;
}

.nuload_dialog_send {
    border-radius: 50px;
    background: #FFDF9B;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    line-height: 38px;
    /* 166.667% */
    letter-spacing: 0.12px;
    height: 38px;
    margin-top: 24px;
    width: -webkit-fill-available;
    width: -moz-available;
    justify-content: center;
    display: flex;
}

.dialog_title {
    color: #812D15;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 4px;
    width: 192px;
    text-align: center;
}

.dialog_intro {
    color: #F6840B;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: left;
    margin-bottom: 4px;
}

.dialog_msg {
    color: #999;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 26px;
}

.dialog_close_layout {
    display: flex;
    flex-direction: row;
    margin-bottom: -30px;
    margin-top: 16px;
    display: none;

}

.icon_app_close_img {
    width: 28px;
    height: 28px;
    background-image: url("../../assets/icon_dialog_close.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.icon_check_icon_img {
    width: 100px;
    height: 100px;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
}

.icon_check_icon_lot {
    width: 100px;
    height: 100px;
    display: flex;
}


.checkin_xp {
    width: 134px;
    height: 98px;
}

.check_ll_sp {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: -webkit-fill-available;
    width: -moz-available;
    margin-top: 14px;
    display: none;
}

.check_ll_ct {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.check_time {
    color: #812D15;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.check_intor {
    color: #999;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 4px;
}

.w_r_bg {
    display: flex;
    flex-direction: column;
    width: -webkit-fill-available;
    width: -moz-available;
    background: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    align-items: center;
    padding-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
}

.check_in_top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    margin-left: 16px;
    margin-right: 16px;
}

.empty_view {
    width: 100vw;
    height: 100vh;
    position: absolute;
    bottom: 0;
}

.loading_logo {
    width: 18px;
    height: 18px;
    background-image: url("../../assets/icon_loading.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 10px;
    animation: rotate 2s linear infinite;
}

.p_layout {
    display: flex;
    width: -webkit-fill-available;
    width: -moz-available;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>